<template>
    <div class="card box widget-social pt-2 pb-2" :class="componentStyle">
        <widgetTitleBar :moduleData="this.moduleData" :widgetInfo="content" :alarmList="this.alarmList" :menu-items="this.items" @menu-click="($value) => this.toggle($value)"></widgetTitleBar>
        <OverlayPanel
            class="param-overlay"
            ref="alarmOverlay"
            appendTo="body"
            :autoZIndex="true"
            @show="focusElement" 
            :dismissable="true"
            :showCloseIcon="true"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ height: 'auto' }"
        >
            <div v-for="(element) in this.alarmList" :key="element.label">
                <span>🔴 {{ element.label }}</span>
            </div>
        </OverlayPanel>
        <div v-if="isLoading">
            <loader-skeleton :widgetInfo="content"></loader-skeleton>
        </div>
        <OverlayPanel class="param-overlay" ref="periods" appendTo="body" :autoZIndex="true" @show="focusElement" 
            :dismissable="false" :showCloseIcon="true" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ height: '300px' }">
        </OverlayPanel>
        <Dialog 
            v-model:visible="showDiagPeriods"
            @show="focusDiag"
            @hide="hideOP"
            :breakpoints="{ '960px': '85vw', '640px': '90vw' }"
            :style="{ width: '700px' }"
            class="p-fluid"
            >
            <template #header>
                <h5><i class="pi pi-cog">&nbsp;</i>
                    <span class="subtext mt-1">
                        {{ moduleDepartment.key }} - {{ moduleDepartment.label }} ⚡ Vorlauf-Perioden Einstellungen
                    </span>
                </h5>
            </template>
            <div v-if="saveWait" class="flex justify-content-center flex-wrap">
                <ProgressSpinner
                style="width: 50px; height: 50px"
                strokeWidth="4"
                fill="var(--red-600)"
                animationDuration="1s"
                />
            </div>
            <div v-else @keydown.esc="hideOP" @keydown.enter="saveDiag('periods')">
                <loader v-if="dialogLoading" :style="'box'"></loader>
                <TabView v-else :scrollable="true" :activeIndex="diagPeriod">
                    <TabPanel v-for="(element, index) in this.nodeDataPeriods" :key="index">
                        <!-- <Panel :header="returnParameter(element, 'parameter', 'periodName').value + ' - Sollwert'"> -->
                        <template #header>
                            <div class="flex align-items-center gap-2">
                                <span class="white-space-nowrap" :class="this.getDiagDataPeriods(index, 'periodEnable').value ? '' : 'line-through'">{{ index+1 }}: {{ this.getDiagDataPeriods(index, 'periodName').value }}</span>
                            </div>
                        </template>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Sollwert`">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mb-3">
                                            <InputSwitch v-model="this.getDiagDataPeriods(index, 'periodEnable').value" /><span class="ml-2">Periode aktivieren</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                                <div class="field col mr-2">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlMinTemp" ref="vlMinTemp" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'vlMinTemp').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                <label for="vlMinTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlMinTemp').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlMinTemp').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlMaxTemp" ref="vlMaxTemp" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'vlMaxTemp').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                <label for="vlMaxTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlMaxTemp').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlMaxTemp').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3 mb-3">
                                            <InputSwitch v-model="this.getDiagDataPeriods(index, 'minPipeEnable').value" /><span class="ml-2">{{ this.getDiagDataPeriods(index, 'minPipeEnable').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Zeiteinstellungen`" class="mt-2" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                            <template #icons>
                                <i class="fi fi-rr-time-fast bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="flex justify-content-center mb-2">
                                        <SelectButton v-model="this.getDiagDataPeriods(index, 'TimeModeStart').value" :options="this.$store.getters.getTimeType" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                    <div class="field">
                                        <div class="p-inputgroup">
                                            <span v-if="this.getDiagDataPeriods(index, 'TimeModeStart').value !== 0" class="p-inputgroup-addon">
                                                <ToggleButton v-model="this.getDiagDataPeriods(index, 'TimeSetStart').plusminus" onIcon="fi fi-rr-minus" offIcon="fi fi-rr-plus" />
                                            </span>
                                            <span class="p-float-label mr-2">
                                                <InputMask id="minTimeStart" ref="minValueTimeStart" mask="99:99:99"
                                                    placeholder="" slotChar="hh:mm:ss"
                                                    v-model="this.getDiagDataPeriods(index, 'TimeSetStart').value"
                                                    @focus="focusElement" class="p-inputtext-lg w-full" />
                                                <label for="minValueTimeStart" class="mr-2">Periode Beginn</label>
                                            </span>
                                        </div>
                                        <span class="p-float-label mr-2 mt-2">
                                            <InputMask id="transitionLoHi" ref="transitionLoHi" mask="99:99:99"
                                                placeholder="" slotChar="hh:mm:ss"
                                                v-model="this.getDiagDataPeriods(index, 'periodTransition_LoHi').value"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="transitionLoHi" class="mr-2">Aufwärmzeit/°C</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center mb-2">
                                        <SelectButton v-model="this.getDiagDataPeriods(index, 'TimeModeEnd').value" :options="this.$store.getters.getTimeType" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                    <div class="field">
                                        <div class="p-inputgroup">
                                            <span v-if="this.getDiagDataPeriods(index, 'TimeModeEnd').value !== 0" class="p-inputgroup-addon">
                                                <ToggleButton v-model="this.getDiagDataPeriods(index, 'TimeSetEnd').plusminus" onIcon="fi fi-rr-minus" offIcon="fi fi-rr-plus"/>
                                            </span>
                                            <span class="p-float-label">
                                                <InputMask id="minTimeEnd" ref="minValueTimeEnd" mask="99:99:99" placeholder=""
                                                    slotChar="hh:mm:ss" v-model="this.getDiagDataPeriods(index, 'TimeSetEnd').value"
                                                    @focus="focusElement" class="p-inputtext-lg w-full" />
                                                <label for="minValueTimeEnd">Periode Ende</label>
                                            </span>
                                        </div>
                                        <span class="p-float-label mt-2">
                                            <InputMask id="transitionHiLo" ref="transitionHiLo" mask="99:99:99"
                                                placeholder="" slotChar="hh:mm:ss"
                                                v-model="this.getDiagDataPeriods(index, 'periodTransition_HiLo').value"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="transitionHiLo">Abkühlzeit/°C</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Vorlauftemperatur Strahlungskorrektur`" class="mt-2" v-if="getDiagDataPeriods(index, 'periodEnable').value">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3 mb-3">
                                            <InputSwitch v-model="this.getDiagDataPeriods(index, 'vlLightEnable').value" /><span class="ml-2">{{ this.getDiagDataPeriods(index, 'vlLightEnable').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="this.getDiagDataPeriods(index, 'vlLightEnable').value">
                                <div class="field col-12 text-center">
                                    <p class="fg-lightYellow"><span class="text-sm fg-gray">aktueller Korrekturwert: </span>{{ this.getModuleValue('OUT_LightCorrection').value + this.getModuleValue('OUT_LightCorrection').unit }}</p>
                                </div>
                                <div class="formgrid grid p-1">
                                    <div class="field col">
                                        <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                            <i class="fi-rr-sun fg-lightOrange text-lg" />
                                            <span class="ml-2 text-sm">Globalstrahlung</span>
                                        </div>
                                    </div>
                                    <div class="field col">
                                        <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                            <i class="fi-rr-oil-temp fg-red text-lg" />
                                            <span class="ml-2 text-sm">Vorlauftemperatur Korrektur</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="formgrid grid p-1">
                                    <div class="field col mr-2">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label mr-2">
                                                <InputNumber id="vlLightMin" ref="vlLightMin" :min="0" :max="5000"
                                                    v-model="this.getDiagDataPeriods(index, 'vlLightMin').value" autofocus @focus="focusElement"
                                                    :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                    inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                    <label for="vlLightMin" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlLightMin').label }}</label>
                                                <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlLightMin').unit }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                        <i class="fi-rr-arrow-circle-right fg-darkAmber text-5xl" />
                                    </div>
                                    <div class="field col">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label mr-2">
                                                <InputNumber id="vlLightMinTemp" ref="vlLightMinTemp" :min="-100" :max="100"
                                                    v-model="this.getDiagDataPeriods(index, 'vlLightMinTemp').value" autofocus @focus="focusElement"
                                                    :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                    inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                    <label for="vlLightMinTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlLightMinTemp').label }}</label>
                                                <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlLightMinTemp').unit }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="formgrid grid p-1">
                                    <div class="field col mr-2">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label mr-2">
                                                <InputNumber id="vlLightMax" ref="vlLightMax" :min="0" :max="2000"
                                                    v-model="this.getDiagDataPeriods(index, 'vlLightMax').value" autofocus @focus="focusElement"
                                                    :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                    inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                    <label for="vlLightMax" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlLightMax').label }}</label>
                                                <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlLightMax').unit }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                        <i class="fi-rr-arrow-circle-right fg-lightAmber text-5xl" />
                                    </div>
                                    <div class="field col">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label mr-2">
                                                <InputNumber id="vlLightMaxTemp" ref="vlLightMaxTemp" :min="-100" :max="100"
                                                    v-model="this.getDiagDataPeriods(index, 'vlLightMaxTemp').value" autofocus @focus="focusElement"
                                                    :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                    inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                    <label for="vlLightMaxTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlLightMaxTemp').label }}</label>
                                                <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlLightMaxTemp').unit }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Vorlauftemperatur Außentemperatur-Korrektur`" class="mt-2" v-if="getDiagDataPeriods(index, 'periodEnable').value">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3 mb-3">
                                            <InputSwitch v-model="this.getDiagDataPeriods(index, 'vlAtEnable').value" /><span class="ml-2">{{ this.getDiagDataPeriods(index, 'vlAtEnable').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="this.getDiagDataPeriods(index, 'vlAtEnable').value">
                                <div class="field col-12 text-center">
                                    <p class="fg-lightYellow"><span class="text-sm fg-gray">aktueller Korrekturwert: </span>{{ this.getModuleValue('OUT_AtCorrection').value + this.getModuleValue('OUT_AtCorrection').unit }}</p>
                                </div>
                                <div class="formgrid grid p-1">
                                    <div class="field col">
                                        <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                            <i class="fi-rr-temperature-low fg-lightOrange text-lg" />
                                            <span class="ml-2 text-sm">Außentemperatur</span>
                                        </div>
                                    </div>
                                    <div class="field col">
                                        <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                            <i class="fi-rr-oil-temp fg-red text-lg" />
                                            <span class="ml-2 text-sm">Vorlauftemperatur Korrektur</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="formgrid grid p-1">
                                    <div class="field col mr-2">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label mr-2">
                                                <InputNumber id="vlAtStart" ref="vlAtStart" :min="-100" :max="100"
                                                    v-model="this.getDiagDataPeriods(index, 'vlAtStart').value" autofocus @focus="focusElement"
                                                    :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                    inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                    <label for="vlAtStart" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlAtStart').label }}</label>
                                                <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlAtStart').unit }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                        <i class="fi-rr-arrow-circle-right fg-lightAmber text-5xl" />
                                    </div>
                                    <div class="field col">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label mr-2">
                                                <InputNumber id="vlAtStartTemp" ref="vlAtStartTemp" :min="-150" :max="150"
                                                    v-model="this.getDiagDataPeriods(index, 'vlAtStartTemp').value" autofocus @focus="focusElement"
                                                    :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                    inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                    <label for="vlAtStartTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlAtStartTemp').label }}</label>
                                                <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlAtStartTemp').unit }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="formgrid grid p-1">
                                    <div class="field col mr-2">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label mr-2">
                                                <InputNumber id="vlAtEnd" ref="vlAtEnd" :min="-100" :max="100"
                                                    v-model="this.getDiagDataPeriods(index, 'vlAtEnd').value" autofocus @focus="focusElement"
                                                    :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                    inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                    <label for="vlAtEnd" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlAtEnd').label }}</label>
                                                <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlAtEnd').unit }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                        <i class="fi-rr-arrow-circle-right fg-darkAmber text-5xl" />
                                    </div>
                                    <div class="field col">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label mr-2">
                                                <InputNumber id="vlAtEndTemp" ref="vlAtEndTemp" :min="-150" :max="150"
                                                    v-model="this.getDiagDataPeriods(index, 'vlAtEndTemp').value" autofocus @focus="focusElement"
                                                    :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                    inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                    <label for="vlAtEndTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlAtEndTemp').label }}</label>
                                                <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'vlAtEndTemp').unit }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Frostschutz`" class="mt-3" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col mr-2">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="pumpFrostStart" ref="pumpFrostStart" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'pumpFrostStart').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-xl"  />
                                                <label for="pumpFrostStart" class="mr-2">{{ this.getDiagDataPeriods(index, 'pumpFrostStart').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-xl">{{ this.getDiagDataPeriods(index, 'pumpFrostStart').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="pumpFrostValue" ref="pumpFrostValue" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'pumpFrostValue').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-xl"  />
                                                <label for="pumpFrostValue" class="mr-2">{{ this.getDiagDataPeriods(index, 'pumpFrostValue').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-xl">{{ this.getDiagDataPeriods(index, 'pumpFrostValue').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <div class="formgrid grid p-1">
                            <div class="field col">
                                <div class="flex justify-content-center mt-2">
                                    <Button label="Periodenbezeichnung ändern" @click="toogleNameDiag(this.getDiagDataPeriods(index, 'periodName'))" />
                                </div>
                            </div>
                        </div>
                        
                    </TabPanel>
                </TabView>
            </div>
            <template #footer>
                <widgetDialogFooter :widgetName="`${this.$options.name}_periods`" :department="moduleDepartment.key" :exchange="true" format="json" :saveCheck="periodCheck"
                    @diagAbort="diagTogglePeriods"
                    @diagSave="saveDiag('periods')"
                    @import="($value) => {this.nodeDataPeriods = $value}"
                    :exportObject="this.nodeDataPeriods"
                ></widgetDialogFooter>
            </template>
        </Dialog>
        <OverlayPanel ref="misc" appendTo="body" @show="focusElement" :dismissable="false">
        </OverlayPanel>
        <Dialog
            v-model:visible="showDiagMisc"
            @show="focusElement"
            :breakpoints="{ '960px': '85vw', '640px': '90vw' }"
            :style="{ width: '700px' }"
        >
            <template #header>
                <h5><i class="pi pi-cog">&nbsp;</i><span class="subtext mt-1">{{ moduleDepartment.key }} {{ moduleDepartment.label }} ⚡ Allgemeine Einstellungen</span></h5>
            </template>
            <div v-if="saveWait" class="flex justify-content-center flex-wrap">
                <ProgressSpinner
                style="width: 50px; height: 50px"
                strokeWidth="4"
                fill="var(--red-600)"
                animationDuration="1s"
                />
            </div>
            <div v-else @keydown.esc="hideOP" @keydown.enter="saveDiag('misc')">
                <loader v-if="dialogLoading" :style="'box'"></loader>
                <TabView :scrollable="true">
                    <TabPanel header="Heizungsregler">
                        <Panel header="Temperatureinstellungen">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="pitch" ref="pitch" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('pitch').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('pitch').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pitch" class="mr-2">{{ getDiagDataCfg('pitch').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="controllOffHyst" ref="controllOffHyst" :min="-50" :max="100"
                                            v-model="getDiagDataCfg('controllOffHyst').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('controllOffHyst').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="controllOffHyst" class="mr-2">{{ getDiagDataCfg('controllOffHyst').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="scaleRtVlMin" ref="scaleRtVlMin" :min="-50" :max="100"
                                            v-model="getDiagDataCfg('scaleRtVlMin').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('scaleRtVlMin').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="scaleRtVlMin" class="mr-2">{{ getDiagDataCfg('scaleRtVlMin').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="scaleRtVlMax" ref="scaleRtVlMax" :min="-50" :max="100"
                                            v-model="getDiagDataCfg('scaleRtVlMax').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('scaleRtVlMax').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="scaleRtVlMax" class="mr-2">{{ getDiagDataCfg('scaleRtVlMax').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Pumpen-Einstellungen" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="pumpOffDelay" ref="pumpOffDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('pumpOffDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pumpOffDelay" class="mr-2">{{ getDiagDataCfg('pumpOffDelay').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="pumpAutoStart" ref="pumpAutoStart" mask="999:99:99"
                                            placeholder="" slotChar="hhh:mm:ss"
                                            v-model="this.getDiagDataCfg('pumpAutoStart').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pumpAutoStart" class="mr-2">{{ getDiagDataCfg('pumpAutoStart').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="pumpFrostIntOn" ref="pumpFrostIntOn" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('pumpFrostIntOn').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pumpFrostIntOn" class="mr-2">{{ getDiagDataCfg('pumpFrostIntOn').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="pumpFrostIntOff" ref="pumpFrostIntOff" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('pumpFrostIntOff').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pumpFrostIntOff" class="mr-2">{{ getDiagDataCfg('pumpFrostIntOff').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Mischventil-Einstellungen" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-heat bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="runtime" ref="runtime" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('runtime').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="runtime" class="mr-2">{{ getDiagDataCfg('runtime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveDeadzone" ref="valveDeadzone" :min="0" :max="100"
                                            v-model="getDiagDataCfg('valveDeadzone').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveDeadzone').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveDeadzone" class="mr-2">{{ getDiagDataCfg('valveDeadzone').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="pFactor" ref="pFactor" :min="0.1" :max="10000"
                                            v-model="getDiagDataCfg('pFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('pFactor').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pFactor" class="mr-2">{{ getDiagDataCfg('pFactor').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="iFactor" ref="iFactor" :min="0" :max="10000"
                                            v-model="getDiagDataCfg('iFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('iFactor').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="iFactor" class="mr-2">{{ getDiagDataCfg('iFactor').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveRuntimeFactor" ref="valveRuntimeFactor" :min="0" :max="1000"
                                            v-model="getDiagDataCfg('valveRuntimeFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveRuntimeFactor').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveRuntimeFactor" class="mr-2">{{ getDiagDataCfg('valveRuntimeFactor').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="controlPauseTime" ref="controlPauseTime" :min="0" :max="100000"
                                            v-model="getDiagDataCfg('controlPauseTime').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('controlPauseTime').unit}`"
                                            :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="controlPauseTime" class="mr-2">{{ getDiagDataCfg('controlPauseTime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="deadBand" ref="deadBand" :min="0" :max="100"
                                            v-model="getDiagDataCfg('deadBand').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('deadBand').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="deadBand" class="mr-2">{{ getDiagDataCfg('deadBand').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="calcFilterTime" ref="calcFilterTime" :min="0" :max="100000"
                                            v-model="getDiagDataCfg('calcFilterTime').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('calcFilterTime').unit}`"
                                            :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="calcFilterTime" class="mr-2">{{ getDiagDataCfg('calcFilterTime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="calcFilterValue" ref="calcFilterValue" :min="0" :max="100"
                                            v-model="getDiagDataCfg('calcFilterValue').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('calcFilterValue').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="calcFilterValue" class="mr-2">{{ getDiagDataCfg('calcFilterValue').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="setpointDelay" ref="setpointDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('setpointDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="setpointDelay" class="mr-2">{{ getDiagDataCfg('setpointDelay').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="ctrlDelay" ref="ctrlDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('ctrlDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="ctrlDelay" class="mr-2">{{ getDiagDataCfg('ctrlDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('iFactorPosDiff').value" /><span class="ml-2">{{ this.getDiagDataCfg('iFactorPosDiff').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Manueller Betrieb" class="mt-2">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('enableManual').value" /><span class="ml-2">{{ this.getDiagDataCfg('enableManual').label }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('valveManual').value" /><span class="ml-2">{{ this.getDiagDataCfg('valveManual').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                </div>
                                <div class="field col" v-if="this.getDiagDataCfg('valveManual').value">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveManualSet" ref="valveManualSet" :min="0" :max="100"
                                            v-model="getDiagDataCfg('valveManualSet').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveManualSet').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveManualSet" class="mr-2">{{ getDiagDataCfg('valveManualSet').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel> 
                    </TabPanel>
                    <TabPanel header="Luftheizungsmodus" v-if="isMaster">
                        <Panel header="Luftheizungsmodus Einstellung">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('enableHotairMode').value" /><span class="ml-2">{{ this.getDiagDataCfg('enableHotairMode').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel> 
                        <Panel header="Temperatureinstellungen" class="mt-2" v-if="this.getDiagDataCfg('enableHotairMode').value">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="vlHotairModeOn" ref="vlHotairModeOn" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('vlHotairModeOn').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('vlHotairModeOn').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="vlHotairModeOn" class="mr-2">{{ getDiagDataCfg('vlHotairModeOn').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="fanOffHyst" ref="fanOffHyst" :min="-50" :max="100"
                                            v-model="getDiagDataCfg('fanOffHyst').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('fanOffHyst').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="fanOffHyst" class="mr-2">{{ getDiagDataCfg('fanOffHyst').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Verzögerungen" class="mt-2" v-if="this.getDiagDataCfg('enableHotairMode').value">
                            <template #icons>
                                <i class="fi fi-rr-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="fanMinOntime" ref="fanMinOntime" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('fanMinOntime').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="fanMinOntime" class="mr-2">{{ getDiagDataCfg('fanMinOntime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="fanMinOfftime" ref="fanMinOfftime" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('fanMinOfftime').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="fanMinOfftime" class="mr-2">{{ getDiagDataCfg('fanMinOfftime').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="fanOffDelay" ref="fanOffDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('fanOffDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="fanOffDelay" class="mr-2">{{ getDiagDataCfg('fanOffDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Manueller Betrieb" class="mt-2" v-if="this.getDiagDataCfg('enableHotairMode').value">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('enableFanManual').value" /><span class="ml-2">{{ this.getDiagDataCfg('enableFanManual').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel> 
                    </TabPanel>
                    <TabPanel header="Alarme Vorlauf">
                        <Panel header="Alarmeinstellungen Minimum-Temperatur Vorlauf">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlMin" ref="alarmVlMin" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlMin').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlMin').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMin" class="mr-2">{{ getDiagDataCfg('alarmVlMin').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlMinPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlMinDiff" ref="alarmVlMinDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlMinDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlMinDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMinDiff" class="mr-2">{{ getDiagDataCfg('alarmVlMinDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlMinDelay" ref="alarmVlMinDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlMinDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMinDelay" class="mr-2">{{ getDiagDataCfg('alarmVlMinDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Maximum-Temperatur Vorlauf" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-temperature-high bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlMax" ref="alarmVlMax" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlMax').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlMax').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMax" class="mr-2">{{ getDiagDataCfg('alarmVlMax').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlMaxPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlMaxDiff" ref="alarmVlMaxDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlMaxDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlMaxDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMaxDiff" class="mr-2">{{ getDiagDataCfg('alarmVlMaxDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlMaxDelay" ref="alarmVlMaxDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlMaxDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMaxDelay" class="mr-2">{{ getDiagDataCfg('alarmVlMaxDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Differenz-Temperatur Vorlauf" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-temperature-high bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlDiff" ref="alarmVlDiff" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlDiff" class="mr-2">{{ getDiagDataCfg('alarmVlDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlDiffPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlDiffDiff" ref="alarmVlDiffDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlDiffDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlDiffDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlDiffDiff" class="mr-2">{{ getDiagDataCfg('alarmVlDiffDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlDiffDelay" ref="alarmVlDiffDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlDiffDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlDiffDelay" class="mr-2">{{ getDiagDataCfg('alarmVlDiffDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Sensoralarm Vorlauf" class="mt-3" v-if="isMaster">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlSensorDiff" ref="alarmVlSensorDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlSensorDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlSensorDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSensorDiff" class="mr-2">{{ getDiagDataCfg('alarmVlSensorDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlSensorDelay" ref="alarmVlSensorDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlSensorDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSensorDelay" class="mr-2">{{ getDiagDataCfg('alarmVlSensorDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlSensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Sensoreinstellungen" v-if="isMaster">
                        <Panel header="Filtereinstellungen" class="mt-0">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="tempFilterTime" ref="tempFilterTime" :min="0" :max="100000"
                                                v-model="this.getDiagDataCfg('tempFilterTime').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('tempFilterTime').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="tempFilterTime" class="mr-2">{{ this.getDiagDataCfg('tempFilterTime').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="tempFilterValue" ref="tempFilterValue" :min="0" :max="1"
                                                v-model="this.getDiagDataCfg('tempFilterValue').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('tempFilterValue').unit}`"
                                                :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="tempFilterValue" class="mr-2">{{ this.getDiagDataCfg('tempFilterValue').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="calcFilterTime" ref="calcFilterTime" :min="0" :max="100000"
                                                v-model="this.getDiagDataCfg('calcFilterTime').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('calcFilterTime').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="calcFilterTime" class="mr-2">{{ this.getDiagDataCfg('calcFilterTime').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="calcFilterValue" ref="calcFilterValue" :min="0" :max="10000"
                                                v-model="this.getDiagDataCfg('calcFilterValue').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('calcFilterValue').unit}`"
                                                :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="calcFilterValue" class="mr-2">{{ this.getDiagDataCfg('calcFilterValue').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="filterTypeVlSet" ref="filterTypeVlSet" :min="0" :max="10"
                                                v-model="this.getDiagDataCfg('filterTypeVlSet').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('filterTypeVlSet').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="filterTypeVlSet" class="mr-2">{{ this.getDiagDataCfg('filterTypeVlSet').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="lightHyst" ref="lightHyst" :min="0" :max="1000"
                                                v-model="this.getDiagDataCfg('lightHyst').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('lightHyst').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="lightHyst" class="mr-2">{{ this.getDiagDataCfg('lightHyst').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung Vorlauffühler" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-cog bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensInMin" ref="vlSensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('vlSensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensOutMin" ref="vlSensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlSensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('vlSensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensInMax" ref="vlSensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('vlSensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensOutMax" ref="vlSensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlSensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('vlSensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensOffset" ref="vlSensOffset" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlSensOffset').value"
                                                :suffix="` ${this.getDiagDataCfg('vlSensOffset').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensOffset" class="mr-2">{{ this.getDiagDataCfg('vlSensOffset').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field mt-2">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="IN_VL" ref="IN_VL"
                                                v-model="this.getModuleValue('IN_VL').value" mode="decimal"
                                                :suffix="` ${this.getModuleValue('IN_VL').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                class="p-inputtext-lg w-full" :disabled="true" />
                                            <label for="IN_VL" class="mr-2">{{ this.getModuleValue('IN_VL').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field mt-2">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="OUT_VL" ref="OUT_VL"
                                                v-model="this.getModuleValue('OUT_VL').value" mode="decimal"
                                                :suffix="` ${this.getModuleValue('OUT_VL').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                class="p-inputtext-lg w-full" :disabled="true" />
                                            <label for="OUT_VL" class="mr-2">{{ this.getModuleValue('OUT_VL').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Alarmausgang" v-if="isMaster">
                        <widgetAlarmOutput :value="this.getDiagDataCfg('alarmAssignedOutput')" @setOutput="($value) => {this.getDiagDataCfg('alarmAssignedOutput').value = $value}"></widgetAlarmOutput>
                    </TabPanel>
                </TabView>
            </div>
            <template #footer>
                <widgetDialogFooter :widgetName="`${this.$options.name}_misc`" :department="moduleDepartment.key" :exchange="true" format="json"
                    @diagAbort="diagToggleMisc"
                    @diagSave="saveDiag('misc')"
                    @import="($value) => {this.nodeDataCfg = $value}"
                    :exportObject="this.nodeDataCfg"
                ></widgetDialogFooter>
            </template>
        </Dialog>

        <div v-if="!isLoading">
            <div class="flex justify-content-between align-items-center p-0 flex-wrap">
                <div class="flex justify-content-start align-items-center p-0">
                    <moduleIconEnat :icon="moduleData.metadata.icon" :alarmStatus="alarmStatus" :alarmQueue="alarmQueue" @toogleAlarmOverlay="toogleAlarmOverlay"></moduleIconEnat>
                    <div class="hidden sm:flex mt-1 ml-2">
                        <widget-mini-progress label="Mischer" :value="getModuleValue('OUT_Position')"></widget-mini-progress>
                        <widget-mini-binary-pulse label="UWP" :value="this.getModuleValue('OUT_UWP')"></widget-mini-binary-pulse>
                        <widget-mini-binary-pulse label="Lüfter" :value="this.getModuleValue('OUT_FAN')" v-if="this.getModuleValue('CFG.enableHotairMode').value === true"></widget-mini-binary-pulse>
                    </div>
                    <div class="flex flex-column mt-3">

                    </div>
                </div>
                <div class="flex justify-content-end align-items-center p-0">
                    <widget-header :value="this.getModuleValue('OUT_VL')" :moduleData="this.moduleData" @showChart="showChart('value1')" :fgColor="fontColor" />
                </div>
            </div>

            <div class="stats flex mt-1">
                <!-- <div class="left flex flex-column"> -->
                <div class="left">
                    <ul class="widget-list">
                        <Widget_rowValues2 :title="'Raum Ist/Soll'" :value1="this.getModuleValue('OUT_RT')" :value2="this.getModuleValue('OUT_SetpointRt')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'Mischer Ist/Soll'" :value1="this.getModuleValue('OUT_Position')" :value2="this.getModuleValue('OUT_PositionSetpoint')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'Vorlauf Ist/Soll'" :value1="this.getModuleValue('OUT_VL')" :value2="this.getModuleValue('OUT_SetpointVl')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'Differenz RT/VL'" :value1="this.getModuleValue('OUT_DiffRt')" :value2="this.getModuleValue('OUT_DiffVl')"></Widget_rowValues2>
                    </ul>
                </div>
                <div class="right flex flex-column">
                    <div class="flex flex-wrap">
                        <div class="flex-1 align-items-center justify-content-center mt-3">
                            <button-enat title="Heizperioden" subtitle="Einstellungen Heizungstemperaturen" icon="fi fi-rr-time-twenty-four" fgColor="yellow" bgColor="crimson"
                                :badge="periodIndex + 1" @click="toggleOP($event, 'periods')" >
                            </button-enat>
                        </div>
                        <div class="flex-1 align-items-center justify-content-center mt-3">
                            <button-enat title="Allgemein" subtitle="Alarme, Meldungen" icon="fi fi-rr-settings" fgColor="yellow" bgColor="darkSteel"
                                @click="toggleOP($event, 'misc')" >
                            </button-enat>
                        </div>
                    </div>
                    <div class="flex flex-wrap mt-2">
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="aktuelle Periode" :value="getModuleValue('OUT_CurrentPeriod.periodName').value" :moduleData="moduleData" icon="fi fi-rr-time-twenty-four" />
                        </div>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="VL-MIN" :value="getModuleValueStr('OUT_CurrentPeriod.vlMinTemp')" :moduleData="moduleData" icon="fi fi-rr-temperature-down" />
                        </div>
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="VL-MAX" :value="getModuleValueStr('OUT_CurrentPeriod.vlMaxTemp')" :moduleData="moduleData" icon="fi fi-rr-temperature-up" />
                        </div>
                    </div>
                </div>
            </div>
            <textbox-enat title="Status" :value="currentStatusStr" :moduleData="moduleData" icon="fi fi-rr-comment-alt" />
        </div>
        <Dialog 
            v-model:visible="showDiagName"
            :closable="false"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ width: '450px' }"
            :modal="true"
            class="p-fluid"
        >
            <template #header>
                <p class="nice-font"><i class="fi fi-rr-text"></i><span class="pl-1 mt-1">Bezeichnung ändern</span></p>
            </template>
            <div @keydown.esc="hideNameDiag" @keydown.enter="saveNameDiag(changeDiagName)">
                <Panel>
                    <div class="grid p-fluid">
                        <div class="col-12 pl-5 pr-5">
                            <span class="p-float-label mr-2">
                                <InputText id="periodName" ref="periodName" v-model="changeDiagName.value" locale="de-DE" class="nice-font inputtext-param text-center text-2xl" />
                                <label for="periodName" class="mr-2">Bezeichnung</label>
                            </span>
                        </div>
                    </div>
                </Panel>
            </div>
            <template #footer>
            <Button label="Abbrechen" icon="pi pi-times" class="p-button-text" @click="hideNameDiag" />
            <Button label="Speichern" icon="pi pi-check" class="p-button-text" @click="saveNameDiag(changeDiagName)" />
            </template>
        </Dialog>
        <div v-if="entryDialog === true">
            <dialog-io-single v-bind:showDialog="entryDialog" :dialogObj="ioObj" v-bind:dialogData="ioDialogData"
                @entrySave="
                    ($value) => {
                        changeVal($value);
                    }
                " @entryAbort="hideDialog()"></dialog-io-single>
        </div>
        <div v-if="entryDialog === true">
            <dialog-io-single v-bind:showDialog="entryDialog" :dialogObj="ioObj" v-bind:dialogData="ioDialogData"
                @entrySave="
                    ($value) => {
                        changeVal($value);
                    }
                " @entryAbort="hideDialog()"></dialog-io-single>
        </div>
        <dialog-chart-single :icon="getModuleValue('OUT_VL').icon" :node="getModuleValue('OUT_VL')" v-bind:show="showChart1" @chart-close="showChart1 = false"></dialog-chart-single>
        <dialog-chart-single :icon="getModuleValue('OUT_Position').icon" :node="getModuleValue('OUT_Position')" v-bind:show="showChartValve" @chart-close="showChartValve = false"></dialog-chart-single>
        <dialog-chart-single :icon="getModuleValue('OUT_UWP').icon" :node="getModuleValue('OUT_UWP')" v-bind:show="showChartPump" @chart-close="showChartPump = false"></dialog-chart-single>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';
import helpers from '@/helpers';
import { parseNode, setOpcValueToast } from '@/helpers';
import SocketioService from '@/services/socketioService.js';
import Widget_rowValues2 from '@/components/fragments/widget_rowValues2.vue';
import dialogChartSingle from '@/components/dialog/chartSingle.vue';
import widgetMiniProgress from '@/components/fragments/widgetMiniProgress.vue';
import widgetMiniBinaryPulse from '@/components/fragments/widgetMiniBinaryPulse.vue';
import widgetAlarmOutput from '@/components/fragments/widgetAlarmOutput.vue';
import widgetDialogFooter from '@/components/fragments/widgetDialogFooter.vue';
import moduleIconEnat from '@/components/fragments/moduleIconEnat.vue';
import widgetTitleBar from '@/components/fragments/widgetTitleBar.vue';
// import widgetTimeSet from '@/components/fragments/widgetTimeSet.vue';

export default defineComponent({
    name: 'widgetHeatingGhController',
    setup() { },
    components: {
        Widget_rowValues2,
        dialogChartSingle,
        widgetMiniProgress,
        widgetMiniBinaryPulse,
        widgetAlarmOutput,
        widgetDialogFooter,
        moduleIconEnat,
        widgetTitleBar,
    },
    props: {
        content: {
            type: null,
            required: true,
        },
        dragObj: {
            type: null,
            required: false,
        },
        valueObj: {
            type: null,
            required: false,
        },
        dataObj: {
            type: null,
            required: false,
        },
        styleObj: {
            type: null,
            required: false,
        },
        createdLayout: {
            type: Boolean,
            required: false,
        },
        readyLayout: {
            type: Boolean,
            required: false,
        },
    },
    watch: {
        createdLayout() {
            this.watchCreatedLayout();
        },
        readyLayout() {
            this.watchLayout();
        },
        '$store.getters.getPageData.editMode': function () {
            this.checkEditMode();
        },
        // nodeEntry: {
        //     handler: function(entry) {
        //         // this.filterParameters();
        //         // if (Array.isArray(entries) && entries.length > 0) {
        //         //     this.loading = false;
        //         // } else {
        //         //     this.loading = true;
        //         // }
        //     },
        //     deep: true
        // }
    },
    computed: {
        ...mapGetters({
            editMode: 'getEditMode',
            getNodeWidget: 'getNodeWidget',
            getOneDepartment: 'types/getOneDepartment',
            getOneCategory: 'types/getOneCategory',
            getIoTree: 'getIoTree',
            getStyleColors: 'getStyleColors',
            getStylePatterns: 'getStylePatterns',
            getModules: 'opcua/getModules',
            getModule: 'opcua/getModule',
            getNode: 'opcua/getNode',
            getModuleFetched: 'opcua/getModuleFetched',
            isMaster: 'auth/isMaster',
        }),
        isLoading: function() {
            if (!this.moduleData || !this.getModuleFetched(this.moduleHash) || this.loading) return true;
            return false;
        },
        
        connectedModule: function () {
            if (this.content.data.module) {
                return this.content.data.module;
            }
            return null;
        },
        moduleData: function () {
            if (this.connectedModule) {
                const module = this.getModule(this.connectedModule);
                if (module) return module;
            }
            return null;
        },
        moduleHash: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.source.server !== null && this.moduleData.source.identifier !== null) {
                    return `${this.moduleData.source.server}@${this.moduleData.source.identifier}`
                }
            }
            return null;
        },
        moduleDepartment: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.metadata.department !== null) {
                    return this.getOneDepartment(this.moduleData.metadata.department);
                }
            }
            return { key: store.getters.getNoval, label: store.getters.getNoval };
        },
        moduleCategory: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.metadata.category !== null) {
                    return this.getOneDepartment(this.moduleData.metadata.category);
                }
            }
            return { key: store.getters.getNoval, label: store.getters.getNoval };
        },
        componentName: function () {
            if (this.content.name !== undefined) {
                return this.content.name;
            } else {
                return '???';
            }
        },
        componentLabel: function () {
            if (this.content.label !== undefined) {
                return this.content.label;
            } else if (this.moduleData !== null && this.moduleData.metadata.label) {
                return this.moduleData.metadata.label;
            } else {
                return store.getters.getNoval;
            }
        },
        componentContent: function () {
            if (this.content.content !== undefined) {
                return this.content.content;
            } else {
                return '???';
            }
        },
        componentStyle: function () {
            if (this.content.style && this.content.style !== 'standard') {
                let background = `bg-${this.content.style.background}`;
                if (this.alarmStatus > 0) background = 'alarm';
                return `box ptrn-${this.content.style.pattern} ${background} fg-${this.content.style.foreground}`;
            } else {
                return '';
            }
        },
        fontColor: function () {
            if (this.content.style && this.content.style.foreground) {
                return `fg-${this.content.style.foreground}`;
            }
            return 'gray';
        },
        icon: function () {
            if (this.alarmStatus === 0) {
                return this.moduleData.metadata.icon
            } else {
                return `${this.moduleData.metadata.icon} fg-red pulse-loop cursor-pointer bg-lightCrimson`;
            }
        },
        alarmEntriesCount: function () {
            if (this.getModuleValue(`AlarmEntriesCount`).value > 0) {
                return this.getModuleValue(`AlarmEntriesCount`).value;
            } else {
                return 0;
            }
        },
        alarmStatus: function () {
            let alarmCount = this.alarmEntriesCount;
            for (let i=0; i<this.alarmEntriesCount; i++) {
                // console.log(this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`));
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value <= 0) {
                    alarmCount -= 1;
                }
            }
            return alarmCount;
        },
        alarmQueue: function () {
            let alarmCount = this.alarmEntriesCount;
            for (let i=0; i<this.alarmEntriesCount; i++) {
                // console.log(this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`));
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value === 0) {
                    alarmCount -= 1;
                }
            }
            return alarmCount;
        },
        alarmList: function () {
            let activeAlarms = [];
            for (let i=0; i<this.alarmEntriesCount; i++) {
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value !== 0) {
                    const alarm = {
                        label: this.getModuleValue(`AlarmEntries[${i}].CFG.alarmLabel`).value,
                        state: this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value
                    }
                    activeAlarms.push(alarm);
                }
            }
            return activeAlarms;
        },
        alarmTicker: function () {
            let alarmStr = '';
            for (let i=0; i<this.alarmEntriesCount; i++) {
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value > 0) {
                    alarmStr += `🔴 ${this.getModuleValue(`AlarmEntries[${i}].CFG.alarmLabel`).value} `;
                }
            }
            return alarmStr;
        },
        orientationStr1: function () {
            return helpers.ventOrientation(this.getModuleValue('CFG.ausrichtung').value, 1);
        },
        orientationStr2: function () {
            return helpers.ventOrientation(this.getModuleValue('CFG.ausrichtung').value, 2);
        },
        currentStatusStr: function () {
            return this.getModuleValue('OUT_StatusStr').value;
        },
        currentPositionFloat1: function () {
            return parseFloat(this.getModuleValue('OUT_Stellung_1_Aktuell').value);
        },
        currentPositionFloat2: function () {
            return parseFloat(this.getModuleValue('OUT_Stellung_2_Aktuell').value);
        },
        pumpIcon: function () {
            if (this.getModuleValue('OUT_UWP').value === true) {
                return `pulse-loop fi-rr-arrow-circle-right fg-green`;
            } else {
                return `fi-rr-arrow-circle-right`;
            }
        },
        periodIndex: function () {
            return this.getModuleValue('OUT_CurrentPeriod.periodIndex').value;
        },
        periodCheck: function () {
            if (this.nodeDataPeriods.length > 0) {
                let cnt = 0;
                this.nodeDataPeriods.forEach((period) => {
                    const result = period.find(entry => entry.displayName === 'periodEnable');
                    if (result) {
                        if (result.value === true) cnt+=1;
                    }
                });
                if (cnt > 0) return false;
            }
            return true;
        },
    },
    data() {
        return {
            loading: false,
            showChart1: false,
            showChartValve: false,
            showChartPump: false,
            saveWait: false,
            dialogLoading: false,
            entryDialog: false,
            valveDialog: false,
            ioDialogData: {},
            ioObj: {},
            timeSetGrp: null,
            nodeData: [],
            nodeDataOld: [],
            nodeDataCfg: [],
            nodeDataCfgOld: [],
            nodeDataPeriods: [],
            nodeDataPeriodsOld: [],
            diagPeriod: 0,
            showDiagName: false,
            currentGrp: {
                name: null,
                label: null,
                enable: null,
                timeSet: null,
                limits: {},
                controller: {},
            },
            node: null,
            lala: null,
            showDiagPeriods: false,
            showDiagMisc: false,
            submitted: false,
            selectedKey: {},
            expandedKeys: {},
            items: [],
            items1: [
                {
                    label: 'VL-Perioden',
                    icon: 'fi fi-rr-settings',
                    command: () => {
                        // this.editEntry(this.content);
                        this.toggleOP(null, 'periods');
                    },
                },
                {
                    label: 'Allgemeine Einstellungen',
                    icon: 'fi fi-rr-settings-sliders',
                    command: () => {
                        // this.editValve(this.content);
                        this.toggleOP(null, 'misc');
                    },
                },
            ],
            items2: [
                {
                    separator: true,
                },
                {
                    label: 'Widget Config',
                    icon: 'pi pi-cog',
                    command: () => {
                        this.editEntry(this.content);
                    },
                },
                {
                    label: 'Duplizieren',
                    icon: 'pi pi-clone',
                    command: () => {
                        this.duplicateEntry();
                    },
                },
                {
                    label: 'Löschen',
                    icon: 'pi pi-times',
                    command: () => {
                        this.deleteEntry();
                    },
                },
            ],
        };
    },
    created() {
        this.loading = true;
    },
    mounted() {
        this.checkEditMode();
        if (!this.getModuleFetched(this.moduleHash)) {
            this.loadModule(this.connectedModule).then((module) => {
                const moduleHash = `${module.source.server}@${module.source.identifier}.*`;
                SocketioService.getRedisNodesParam(moduleHash, (err, response) => {
                    if (!err && response) {
                        if (Array.isArray(response) && response.length > 0) {
                            this.setNodesFull(response);
                        }
                    }
                }).then(() => { 
                    if (this.editMode) console.log(`[ENATWIDGET] ${this.moduleHash} : component ready!`);
                    this.setModuleFetched(this.moduleHash);
                    this.loading = false;
                });
            });
        } else {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions({
            loadNode: 'opcua/loadNode',
            loadModule: 'opcua/loadModule',
            setNodesFull: 'opcua/setNodesFull',
            setModuleFetched: 'opcua/setModuleFetched',
        }),
        loadingState(state) {
            if (state) {
                this.loading = true;
            } else {
                this.loading = false;
            }
        },
        getModuleValue(schemeEntry) {
            const key = `${this.moduleHash}.${schemeEntry}`;
            return this.getNode(key);
        },
        getModuleValueStr(schemeEntry) {
            const key = `${this.moduleHash}.${schemeEntry}`;
            const node = this.getNode(key);
            if (typeof node.unit === 'string' && node.unit.length > 0) {
                return `${node.value}${node.unit}`;
            }
            return `${node.value}`;
        },
        getDiagData(key) {
            if (this.nodeData.length > 0) {
                const result = this.nodeData.find(entry => entry.key2 === key);
                return result;
            }
            return null;
        },
        getDiagDataPeriods(index, displayName) {
            if (this.nodeDataPeriods.length > 0 && index >= 0) {
                const result = this.nodeDataPeriods[index].find(entry => entry.displayName === displayName);
                return result;
            }
            return null;
        },
        getDiagDataCfg(displayName) {
            if (this.nodeDataCfg.length > 0 && displayName) {
                const result = this.nodeDataCfg.find(entry => entry.displayName === displayName);
                return result;
            }
            return null;
        },
        watchCreatedLayout() {
            // this.loading = true;
        },
        watchLayout() {
        },
        checkEditMode() {
            if (this.$store.getters.getPageData.editMode) {
                this.items = [...this.items1, ...this.items2];
            } else {
                this.items = [...this.items1];
            }
        },
        clearVals() {
            this.nodeDataCfg = [];
            this.nodeDataCfgOld = [];
            this.nodeDataPeriods = [];
            this.nodeDataPeriodsOld = [];
            this.saveWait = false;
            this.dialogLoading = false;
            this.diagPeriod = 0;
        },
        updateMap() {
            // this.node = helpers.mapNodes(_.cloneDeep(this.nodeEntry.children), null);
            if (this.node && this.node.size > 0) {
                for (let [key, element] of this.node) {
                    const child = store.getters.getMapValue(element.uuid);
                    this.node.set(key, {...child, value: child.value});
                }
            }
        },
        currentMap() {
            let map = new Map();
            if (this.node && this.node.size > 0) {
                for (let [key, element] of this.node) {
                    const child = store.getters.getMapValue(element.uuid);
                    map.set(key, {...child, value: child.value});
                }
                return map;
            }
            return null;
        },
        getParameter(lvl1, lvl2, index) {
            let parameter = null;
            if (!lvl1) return false;
            if (!lvl2) lvl2 = '';
            if (!isNaN(index)) {
                parameter = this.node.get(lvl1 + '[' + index + '].' + lvl2);
            } else {
                parameter = this.node.get(lvl1 + lvl2);
            }
            return parameter;
        },
        returnChild(childStr) {
            if (typeof childStr == 'string' && this.nodeEntry !== undefined) {
                return helpers.returnChild(this.nodeEntry, childStr);
            } else {
                return null;
            }
        },
        returnParameter(node, key, parameter) {
            return helpers.returnParameter(node, key, parameter);
        },
        returnParameterValue(node, key, parameter, unit) {
            return helpers.returnParameterValue(node, key, parameter, unit);
        },
        timeDialog(time) {
            console.log(time);
        },
        toogleAlarmOverlay(event) {
            this.$refs.alarmOverlay.toggle(event);
        },
        toggle(event) {
            this.$refs.menu.toggle(event);
            // this.this.getModuleValueStatusIOTree();
            // this.getOPCAppTree();
        },
        toggleOP(event, grp) {
            if (grp === 'periods') {
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.CFG.periods*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            let tmpNodes = [];
                            tmpNodes = JSON.parse(JSON.stringify(response));
                            tmpNodes.forEach((entry) => {
                                if (entry.child1) {
                                    const child = JSON.parse(entry.child1)
                                    if (child.index >= 0) {
                                        if (!Array.isArray(this.nodeDataPeriods[child.index])) {
                                            this.nodeDataPeriods[child.index] = [];
                                        }
                                        this.nodeDataPeriods[child.index].push(entry);
                                    }
                                }
                                // console.log(entry);
                            });
                            this.nodeDataPeriodsOld = JSON.parse(JSON.stringify(this.nodeDataPeriods));
                            console.log(this.nodeDataPeriods);
                            console.log(this.nodeDataPeriodsOld);
                            // console.log(this.getDiagDataHzg(0, 'periodName'));
                        }
                    }
                }).then(() => {
                    this.showDiagPeriods = true;
                });        
            } else if (grp === 'periodsVents') {
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.Perioden_Lueftung*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            let tmpNodes = [];
                            tmpNodes = JSON.parse(JSON.stringify(response));
                            tmpNodes.forEach((entry) => {
                                if (entry.child0) {
                                    const child = JSON.parse(entry.child0)
                                    if (child.index >= 0) {
                                        if (!Array.isArray(this.nodeDataLft[child.index])) {
                                            this.nodeDataLft[child.index] = [];
                                        }
                                        this.nodeDataLft[child.index].push(entry);
                                    }
                                }
                                // console.log(entry);
                            });
                            this.nodeDataLftOld = JSON.parse(JSON.stringify(this.nodeDataLft));
                            console.log(this.nodeDataLft);
                            console.log(this.nodeDataLftOld);
                            // console.log(this.getDiagDataHzg(0, 'periodName'));
                        }
                    }
                }).then(() => {
                    this.showDiagVents = true;
                }); 
            } else if (grp === 'misc') {
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.CFG*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            this.nodeDataCfg = JSON.parse(JSON.stringify(response));
                            this.nodeDataCfgOld = JSON.parse(JSON.stringify(response));
                        }
                            console.log(this.nodeDataCfg);
                            console.log(this.nodeDataCfgOld);
                            // console.log(this.getDiagDataHzg(0, 'periodName'));
                        }
                }).then(() => {
                    this.showDiagMisc = true;
                }); 
            }
        },
        diagTogglePeriods() {
            if (this.showDiagPeriods) {
                this.showDiagPeriods = false;
            } else {
                this.showDiagPeriods = true;
            }
            this.hideOP();
        },
        diagToggleMisc() {
            if (this.showDiagMisc) {
                this.showDiagMisc = false;
            } else {
                this.showDiagMisc = true;
            }
            this.hideOP();
        },
        hideOP() {
            this.clearVals();
        },
        saveDiag(diag) {
            if (diag) {
                const saveArray = [];
                this.dialogLoading = true;
                this.saveWait = true;

                if (diag === 'periods' && !this.periodCheck) {
                    console.log(this.nodeDataPeriods);
                    console.log(this.nodeDataPeriodsOld);
                    const flatHzg = this.nodeDataPeriods.flatMap(innerArr => innerArr);
                    const flatHzgOld = this.nodeDataPeriodsOld.flatMap(innerArr => innerArr);
                    console.log(flatHzg);
                    console.log(flatHzgOld);

                    flatHzg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = flatHzgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                } else if (diag === 'periodsLft') {
                    console.log(this.nodeDataLft);
                    console.log(this.nodeDataLftOld);
                    const flatHzg = this.nodeDataLft.flatMap(innerArr => innerArr);
                    const flatHzgOld = this.nodeDataLftOld.flatMap(innerArr => innerArr);
                    console.log(flatHzg);
                    console.log(flatHzgOld);

                    flatHzg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = flatHzgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                } else if (diag === 'misc') {
                    console.log(this.nodeDataCfg);
                    console.log(this.nodeDataCfgOld);
                    this.nodeDataCfg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = this.nodeDataCfgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                }
                
                // console.log(saveArray);
                if (saveArray.length > 0) {
                    SocketioService.setOpcValue(saveArray, (err, response) => {
                        if (err) {
                            console.log(err);
                        } else {
                            console.log(response);
                            setOpcValueToast(response, this.$root);
                            this.dialogLoading = false;
                            if (diag === 'periods') this.showDiagPeriods = false;
                            if (diag === 'misc') this.showDiagMisc = false;
                            this.hideOP();
                        }
                    });
                } else {
                    if (diag === 'periods' && !this.periodCheck) {
                        this.saveDiagNoChanges();
                        this.showDiagPeriods = false;
                    } else if (diag === 'periods' && this.periodCheck) {
                        this.saveDiagNoPeriods();
                    } else if (diag === 'misc') {
                        this.saveDiagNoChanges();
                        this.showDiagMisc = false;
                    }
                }
            }
        },
        saveDiagNoChanges() {
            setOpcValueToast(null, this.$root);
            this.dialogLoading = false;
            this.hideOP();
        },
        saveDiagNoPeriods() {
            this.$toast.add({
                severity: 'warn',
                summary: 'Eine Periode aktivieren!',
                detail: 'Es muss zumindest eine Periode aktiviert werden.',
                life: 3000,
            });
            this.dialogLoading = false;
            this.saveWait = false;
        },
        toogleNameDiag(name) {
            this.changeDiagName = JSON.parse(JSON.stringify(name));
            this.showDiagName = true;
        },
        hideNameDiag() {
            this.changeDiagName = null;
            this.showDiagName = false;
        },
        saveNameDiag(node) {
            console.log(node);
            if (node.child1) {
                const child = JSON.parse(node.child1);
                if (child.index >= 0) {
                    console.log(child.index)
                    let obj2 = null;
                    obj2 = this.nodeDataPeriods[child.index].find((item) => item.identifier === node.identifier);
                    if (obj2) {
                        if (typeof this.changeDiagName.value === 'string' && this.changeDiagName.value.length > 0) {
                            obj2.value = this.changeDiagName.value;
                        }
                        console.log(obj2);
                    }
                }
            }
            this.hideNameDiag();
        },
        focusElement(event) {
            if (event !== undefined) {
                event.target.select();
            }
        },
        hideDialog() {
            this.entryDialog = false;
            this.submitted = false;
            // clearInterval(this.intval_Value);
            // this.getUserList();
        },
        resetDialogData() {
            this.ioDialogData = {
                style: {},
                components: {},
                data: {},
            };
            this.selectedKey = {};
            this.expandedKeys = {};
        },
        changeVal(ioData) {
            console.log(ioData);
            this.$emit('entrySave', ioData);
        },
        editEntry(ioData) {
            this.ioDialogData = JSON.parse(JSON.stringify(ioData));
            this.ioObj = JSON.parse(JSON.stringify(this.moduleData));
            this.entryDialog = true;
        },
        saveDialog() {
            this.submitted = true;
            if (this.ioDialogData.i) {
                this.$emit('entrySave', this.ioDialogData);
                this.entryDialog = false;
                this.resetDialogData();
            }
        },
        duplicateEntry() {
            this.$emit('entryDuplicate', this.content);
            this.resetDialogData();
        },
        deleteEntry() {
            this.$emit('entryDelete', this.content);
            this.resetDialogData();
        },
        expandNode(node) {
            this.expandedKeys[node.key] = true;
            if (node.children && node.children.length) {
                for (let child of node.children) {
                    this.expandNode(child);
                    if (child.key === this.ioObj._id) {
                        this.selectedKey[this.ioObj._id] = true;
                    }
                }
            }
        },
        onNodeSelect(node) {
            const newObj = store.getters.getValue(node.key);
            this.selectedKey = node.key;
            this.ioDialogData.data.id = node.key;

            this.$toast.add({
                severity: 'success',
                summary: 'Node ausgewählt',
                detail: newObj.metadata.name + '\n' + this.selectedKey + '\n' + newObj.nodeId,
                life: 3000,
            });
        },
        editValve(ioData) {
            console.log(ioData);
        },
        hideValveDialog() {
            this.valveDialog = false;
            this.submitted = false;
            // clearInterval(this.intval_Value);
            // this.getUserList();
        },
        focusDiag(event) {
            this.periodDiagDelay(event);
        },
        periodDiagDelay(event) {
            setTimeout(() => {
                this.diagPeriod = this.periodIndex;
                this.focusElement(event);
            }, 300);
        },
        showChart(value) {
            if (value === 'value1') this.showChart1 = true;
            else if (value === 'valve') this.showChartValve = true;
            else if (value === 'pump') this.showChartPump = true;
        },
    },
});
</script>

<style lang="scss" scoped>
.bounce-enter-active {
    animation: bounce-in 0.5s;
    // transition: opacity .5s;
}

.bounce-leave-active {
    animation: bounce-out 0.5s;
    // transition: opacity .5s;
}

.slide-fade-enter-active {
    transition: all 0.5s ease;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for <2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
}

.pulse-enter-active {
    animation: pulse 1s;
}

.pulse-leave-active {
    animation: pulse 0.5s;
}

.pulse-loop {
    animation: pulse 1s;
    animation-iteration-count: infinite;
}

.fade-in-enter-active {
    animation: fadeIn linear 2s;
}

.fade-in-leave-active {
    animation: fadeOut linear 2s;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes fadeInOut {
    0% {
        // opacity: 0;
    }
    50% {
        // opacity: 1;
        background-color: rgba(117, 18, 0, 0.5);
    }
    100% {
        // opacity: 0;
    }
}

@keyframes pulse {
    0% {
        // transform: scale(1); /* scaling to 0 */
        opacity: 0.8;
        // color: yellowgreen;
        // transform-origin: center center;
        // transform: scaleY(.9);
        text-shadow: black 2px 0 10px;
        transform: scale(0.9);
        /* increasing the size */
    }

    30% {
        transform: scale(1.1);
        /* increasing the size */
        text-shadow: gray 1px 0 10px;
    }

    100% {
        transform: scale(1);
        /* seeting back to initial size */
        opacity: 1;
    }
}

.alarm {
    animation: fadeInOut 1s infinite;
    -webkit-animation: fadeInOut 1s infinite;
}

.grid {
    margin: 0 -0.5em 0 -0.5em !important;
}

.col {
    // line-height: 1.4em !important;
    margin: 0 !important;
    padding: 0 !important;
}

.p-divider {
    margin: 0 !important;
    padding: 0 !important;
}

.box {
    overflow: hidden;
    // text-shadow: 1px 1px 1px black;
}

.card {
    font-family: 'SensorFont';
    line-height: 1.3rem;
    position: relative;
}

.text-normal {
    line-height: 0;
}
// .list-enter-active,
// .list-leave-active {
//   transition: all 0.5s ease;
//   transform: scale(0.7); /* increasing the size */
// }
// .list-enter-from,
// .list-leave-to {
//   opacity: 0;
//   transform: scale(1); /* increasing the size */
// }
.list-enter-active {
    animation: list 1s;
}

.list-leave-active {
    animation: list 0.5s;
}

@keyframes list {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
.p-togglebutton {
    font-size: 0.8rem;
    line-height: 1rem;
    padding: 0.2rem;
    margin: 0;
}
</style>